import type { Component } from 'solid-js'
import { For, Show } from 'solid-js'
import Button from '~/components/Button'
import Card from '~/components/Card'
import { P } from '~/utils/permissions'
import type { TabNotasProps } from './types'

const TabNotas: Component<TabNotasProps> = props => {
  return (
    <>
      <div class="flex justify-end mb-4">
        <Show when={props.can(P.customers.update)}>
          <Button size="sm" variant="soft" color="primary" onClick={() => props.setNoteModal(true)} prependIcon="material-symbols-light:add">
            Nueva nota
          </Button>
        </Show>
      </div>
      <div class="space-y-3">
        <For each={props.data.notes ?? []} fallback={<p class="text-foreground-subtle">Sin notas registradas.</p>}>
          {note => (
            <Card>
              <Card.Body>
                <p class="text-sm text-foreground">{note.note}</p>
                <p class="text-xs text-foreground-subtle mt-2">{new Date(note.createdAt).toLocaleString('es-CO')}</p>
              </Card.Body>
            </Card>
          )}
        </For>
      </div>
    </>
  )
}

export default TabNotas
